import { Button, CascadePicker, DatePicker, Form, Input, NavBar, Picker, Popover, SearchBar, Switch, TextArea } from 'antd-mobile'
import { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router'
import queryString from 'query-string'
import { MessageError } from '../../component/Common/MessageError/MessageError'
import Loading from '../../component/Common/Loading/Loading'
import dayjs from 'dayjs'
import { ClockCircleTwoTone, SaveOutlined } from '@ant-design/icons'
import { durationOptions, hoursOfDay } from '../../utils/utility'
import { createAppointment, getAppointmentDetail, getAppointments, updateAppointment } from '../../redux/actions/appointment/appointment'
import { AddCircleOutline, DeleteOutline, QuestionCircleFill } from 'antd-mobile-icons'
import decodeHtmlEntities from '../../utils/UnexcapeString/UnexcapeString'
import ClientSearch from '../../component/CreateEditAppointment/ClientSearch'
import ClientCard from '../../component/CreateEditAppointment/ClientCard'
import duration from 'dayjs/plugin/duration'
import { safeParse } from "../../utils/utility"
import './CreateEditAppointment.css'
dayjs.extend(duration)

const CreateEditAppointment = (props) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const location = useLocation()
    const [form] = Form.useForm()
    const { error, message, loading, appointments, appointmentDetail } = useSelector(state => state.appointment)
    const { staff, menu, business,
        // staffHour
    } = useSelector(state => state.generalInfo)
    // const [availableHours, setAvailableHours] = useState([]);
    let queryObject = queryString.parse(location.search)
    const { date, start, isEdit, aid } = queryObject
    const [currentClient, setCurrentClient] = useState(null)
    const [isHideClientPhoneNumber, setIsHideClientPhoneNumber] = useState(false)
    const { message: messageBusinessClient, error: errorBusinessClient } = useSelector(state => state.businessClient)
    const [blockTimes, setBlockTimes] = useState([])
    const [searchText, setSearchText] = useState('')
    const cascadeRefs = useRef({})


    const groupedMenu = menu.reduce((acc, item) => {
        const category = item.serviceCategory;
        const existingCategory = acc.find(cat => cat.value === category._id);
        if (!existingCategory) {
            acc.push({
                value: category._id,
                label: decodeHtmlEntities(category.name),
                children: [{ value: item._id, label: decodeHtmlEntities(item.name) + ` - $${item.price}` }]
            });
        } else {
            if (!item.isSubService) {
                existingCategory.children.push({ value: item._id, label: decodeHtmlEntities(item.name) + ` - $${item.price}` });
            }
        }
        return acc;
    }, []);

    const [filteredMenu, setFilteredMenu] = useState(groupedMenu)


    const filterServices = (searchValue) => {
        setSearchText(searchValue)

        if (!searchValue || searchValue.trim() === '') {
            // If search is empty, show all grouped menu
            setFilteredMenu(groupedMenu)
            return
        }

        const filtered = groupedMenu.map(category => {
            // Filter services within each category - use 'children' instead of 'services'
            const filteredServices = category.children.filter(service => {
                // Find the actual service object from menu to get more details
                const serviceDetails = menu.find(item => item._id === service.value)

                if (!serviceDetails) return false

                // Filter by service name (case insensitive)
                const nameMatch = `${decodeHtmlEntities(serviceDetails.name).toLowerCase()} - $${serviceDetails.price}`.includes(searchValue.toLowerCase())

                // If it's a combo service, also search in sub-services
                if (serviceDetails.type === "Combo" && serviceDetails.subServices) {
                    const subServiceMatch = serviceDetails.subServices.some(subServiceId => {
                        const subService = menu.find(item => item._id === subServiceId)
                        return subService && subService.name.toLowerCase().includes(searchValue.toLowerCase())
                    })
                    return nameMatch || subServiceMatch
                }

                return nameMatch
            })

            // Return category with filtered services, only if it has matching services
            return {
                ...category,
                children: filteredServices // use 'children' instead of 'services'
            }
        }).filter(category => category.children.length > 0) // Remove categories with no matching services
        setFilteredMenu(filtered)
    }

    useEffect(() => {
        MessageError(messageBusinessClient, errorBusinessClient)
        MessageError(message, error)
    }, [message, error, messageBusinessClient, errorBusinessClient])

    useEffect(() => {
        if (appointmentDetail && message) {
            navigate(`/?date=${date}`)
        }
    }, [appointmentDetail, message, date, navigate])

    useEffect(() => {
        const business = localStorage.getItem("business") ? safeParse("business") : null
        if (business && business.isHideClientPhoneNumber) {
            setIsHideClientPhoneNumber(true)
        }
        if (business) {
            dispatch(getAppointments(date, business.timeZone))
        }
        if (aid && isEdit) {
            dispatch(getAppointmentDetail(aid))
        }
    }, [date, dispatch, aid, isEdit])

    useEffect(() => {
        if (appointments && appointments.length > 0) {
            const newBlockTimes = appointments
                .flatMap(appointment =>
                    appointment.services.map(service => ({
                        ...service,
                    }))
                )
                .filter(service => service.staff === staff._id)
            setBlockTimes(newBlockTimes)
        }
    }, [appointments, staff])

    useEffect(() => {
        if (isEdit && appointmentDetail) {
            const services = appointmentDetail.services.filter(service => service.staff === staff._id).map((service, index) => ({
                _id: [index, service._id],
                name: service.name,
                price: service.price,
                start: [dayjs(service.start, "HH:mm").format("HH:mm")],
                end: dayjs(service.end, "HH:mm").format("HH:mm"),
                duration: [service.duration],
                preferred: service.preferredStaff === staff.name,
                isOldService: true,
            }))
            form.setFieldsValue({
                date: dayjs(appointmentDetail.date).toDate(),
                services: services,
                notes: appointmentDetail.notes,
            })
            if (appointmentDetail.businessClient) {
                const businessClient = appointmentDetail.businessClient
                setCurrentClient({
                    _id: businessClient._id,
                    firstName: businessClient.firstName,
                    lastName: businessClient.lastName,
                    phone: businessClient.phone,
                    email: businessClient.email,
                    note: businessClient.note,
                })
            }

        }
    }, [form, isEdit, appointmentDetail, staff])

    const onFinish = (values) => {

        let appointment = {
            services: values.services.map(service => {
                const serviceId = service._id[1]
                const customName = service.customName
                const serviceName = customName ? customName : service.name ? service.name : menu.find(item => item._id === serviceId).name
                return {
                    _id: serviceId,
                    name: serviceName,
                    price: service.price,
                    duration: service.duration[0],
                    start: service.start[0],
                    end: service.end,
                    staff: staff._id,
                    staffName: staff.name,
                    preferredStaff: service.preferred ? staff.name : null,
                }
            }),
            date: dayjs(values.date).format('YYYY-MM-DD'),
            status: "Confirmed",
            type: 1,
            notes: values.notes,
            createdBy: "Staff",
        };

        if (isEdit) {
            appointment._id = aid;
            dispatch(updateAppointment(appointment));
        }
        else {
            if (currentClient) {
                const clientName = currentClient.firstName || currentClient.lastName ? currentClient.firstName + " " + currentClient.lastName : "Unknown"
                appointment.clientName = clientName;
                appointment.businessClient = currentClient._id;
                appointment.phone = currentClient.phone;
            }

            dispatch(createAppointment(appointment))
        }
        // get the client info for the appointment

    }

    const onDateChange = (date) => {
        navigate(`/appointment/create?date=${dayjs(date).format('YYYY-MM-DD')}`)
        const services = form.getFieldValue('services')
        const newServices = services.map(service => {
            return {
                ...service,
                start: [],
                end: '',
            }
        })
        form.setFieldsValue({
            services: newServices
        })
    }

    const overrideDurationWithSpecialDuration = (service) => {
        let duration = Number(service.duration)
        const extraTime = staff.extraTime

        if (!service.serviceStaffDurations || service.serviceStaffDurations.length === 0) {
            duration = duration + Number(extraTime)
            return duration
        }
        if (service.serviceStaffDurations && service.serviceStaffDurations.length > 0) {
            const foundSpecialDuration = service.serviceStaffDurations.find(duration => duration.staffId === staff._id)
            if (foundSpecialDuration) {
                duration = foundSpecialDuration.duration
            } else {
                duration = duration + Number(extraTime)
            }
        }
        return duration
    }

    const checkServiceTimeWithBlockTimes = (service) => {
        let isOverlapped = false;

        if (service.start[0] && service.end) {
            const serviceStart = Number(service.start[0].replace(/[:]/gi, ""));
            const serviceEnd = Number(service.end.replace(/[:]/gi, ""));
            const blocks = blockTimes
                .filter(block => block.start !== service.start[0])
                .map(block => {
                    const blockStart = Number(
                        block.start.replace(/[:]/gi, "")
                    );
                    const blockEnd = Number(block.end.replace(/[:]/gi, ""));

                    if ((blockStart < serviceEnd) && (blockEnd > serviceStart)) {
                        return block;
                    }
                    return null;
                })
                .filter(blockTime => blockTime);

            if (blocks.length > 0) {
                isOverlapped = true;
            }
        }
        return isOverlapped;
    };

    const calculateEndTime = (start, duration) => {
        let end = "";
        if (start) {
            end = dayjs(start, "HH:mm")
                .add(duration, "minutes")
                .format("HH:mm");
        }
        return end;
    };

    const updateBlockTimes = (services) => {
        let newBlockTimes = appointments
            .flatMap(appointment =>
                appointment.services.map(service => ({
                    ...service,
                }))
            )
            .filter(service => service.staff === staff._id)
        services.forEach(service => {
            const blockTime = { end: service.end, start: service.start[0] }
            if (blockTime.start && blockTime.end) {
                newBlockTimes = [...newBlockTimes, blockTime]
            }
        })
        setBlockTimes(newBlockTimes)
    }

    const onServiceChange = (serviceId, index) => {
        const allowOverlappedAppointment = true
        // const { allowOverlappedAppointment } = business;
        let services = form.getFieldValue('services')
        const selectedService = menu.find(
            service => service._id === serviceId
        );

        if (selectedService.type === "Combo") {
            const subServices = selectedService.subServices.map(subServiceId =>
                menu.find(service => service._id === subServiceId)
            );
            let subIndex = index

            subServices.forEach(subService => {
                let service = services[subIndex];

                service._id[0] = subService.serviceCategory._id;
                service._id[1] = subService._id;
                service.duration[0] = isEdit && service.isOldService
                    ? service.duration[0]
                    : overrideDurationWithSpecialDuration(subService);

                if (service.start[0]) {
                    service.end = calculateEndTime(
                        service.start[0],
                        service.duration
                    );
                    if (!allowOverlappedAppointment && !isEdit && checkServiceTimeWithBlockTimes(service)) {
                        service.start = [];
                        service.end = "";
                    }
                }

                if ((subIndex - index) < subServices.length - 1) {
                    const lastService = services[services.length - 1];

                    let addService = {
                        _id: [],
                        duration: [],
                        name: "",
                        start: [lastService.end],
                        end: "",
                        preferred: service.preferred,

                    };
                    services.splice(subIndex + 1, 0, addService);
                    updateBlockTimes(services)
                    subIndex++
                }

                service.price = subService.price
            });
        }
        else {
            let service = services[index];
            service.duration[0] = isEdit && service.isOldService
                ? service.duration[0]
                : overrideDurationWithSpecialDuration(selectedService);

            if (service.start[0]) {
                service.end = calculateEndTime(
                    service.start[0],
                    service.duration
                );
                if (!allowOverlappedAppointment && !isEdit && checkServiceTimeWithBlockTimes(service)) {
                    service.start = [];
                    service.end = "";
                }
            }

            service.price = selectedService.price
            service.name = selectedService.name

            services[index] = service;
        }
        updateBlockTimes(services)
        form.setFieldsValue({
            services: services
        });
    };

    const addMoreService = (operation) => {
        let services = form.getFieldValue('services')
        const lastService = services[services.length - 1];
        let newService = { _id: [], start: [lastService.end], end: '', duration: [], preferred: true }
        operation.add(newService)
        services = [...services, newService]
        updateBlockTimes(services)
    };

    const removeService = (index, remove) => {
        remove(index);
        let services = form.getFieldValue('services')
        updateBlockTimes(services)
    };

    const onDurationChange = (duration, index) => {
        const { allowOverlappedAppointment } = business;
        const services = form.getFieldValue('services')
        let service = services[index];

        //Update end time if start time was set
        if (service.start[0]) {
            service.end = calculateEndTime(service.start[0], duration);
            if (!allowOverlappedAppointment && !isEdit && checkServiceTimeWithBlockTimes(service)) {
                service.start = [];
                service.end = "";
            }
        }

        service.duration = [duration];
        services[index] = service;
        form.setFieldsValue({
            services: services
        });
        updateBlockTimes(services)
    };

    const onStarttimeChange = (start, index) => {
        let services = form.getFieldValue('services')
        let service = services[index];
        const duration = service.duration[0];
        service.start[0] = start;
        service.end = calculateEndTime(start, duration);
        services[index] = service;
        if (services.length > 1) {
            if (services.filter(service => !service.start[0]).length < 1) {
                services.sort((a, b) => (a.start[0] >= b.start[0] ? 1 : -1));
            }
        }

        form.setFieldsValue({
            services: services
        });

        updateBlockTimes(services)
    };

    const getStaffHour = () => {

        //create an array from 06:00 to 23:45 with 15 minute intervals
        const hours = hoursOfDay()
        return hours

        // const dayOfWeek = dayjs(form.getFieldValue(`date`)).day()
        // const { afterHoursDuration } = business?.appointmentSettings || 0
        // let availableHours = []
        // if (staffHour && staffHour[dayOfWeek] && staffHour[dayOfWeek].isOpen) {
        //     const shifts = staffHour[dayOfWeek].shifts
        //     shifts.forEach(shift => {
        //         hoursOfDay().forEach(hour => {
        //             const formattedHour = dayjs(hour.value, 'HH:mm');
        //             const openTime = dayjs(shift.open, 'HH:mm');
        //             let closeTime = dayjs(shift.close, 'HH:mm');
        //             if (afterHoursDuration) {
        //                 closeTime = closeTime.add(afterHoursDuration, 'minute')
        //             }

        //             if (formattedHour.isBetween(openTime, closeTime, undefined, "[]")) {
        //                 if (!availableHours.includes(hour.value)) {
        //                     availableHours.push(hour)
        //                 }
        //             }
        //         })
        //     })
        // }
        // return availableHours
    }

    const getAvailableTime = (staffHour, service) => {
        let availableTimes = staffHour
        // const { duration, end, start } = service
        // const allowOverlappedAppointment = business?.allowOverlappedAppointment;

        // let otherBlockTimes = blockTimes.filter(block => block.start !== start[0] && block.end !== end)

        // if (!allowOverlappedAppointment && !isEdit && otherBlockTimes.length > 0) {
        //     for (let i = 0; i < otherBlockTimes.length; i++) {
        //         const start = Number(otherBlockTimes[i].start.replace(/[:]/gi, ''))
        //         const end = Number(otherBlockTimes[i].end.replace(/[:]/gi, ''))

        //         availableTimes = availableTimes.filter(time => {
        //             const endTime = calculateEndTime(time.value, duration)
        //             const startTimeInt = Number(time.value.replace(/[:]/gi, ''))
        //             const endTimeInt = Number(endTime.replace(/[:]/gi, ''))
        //             const isEndTimeInWorkingHour = staffHour.find(hour => hour.value === endTime)
        //             return (((startTimeInt < start && endTimeInt <= start) || (startTimeInt >= end)) && isEndTimeInWorkingHour)
        //         })
        //     }
        // } else {
        //     availableTimes = availableTimes.filter(time => {
        //         const endTime = calculateEndTime(time.value, duration)
        //         const isEndTimeInWorkingHour = staffHour.find(hour => hour.value === endTime)
        //         return isEndTimeInWorkingHour
        //     })
        // }
        return availableTimes
    }

    const getWaitingTime = (index) => {
        const services = form.getFieldValue('services')
        const service = services[index]
        let subArray = services.slice(0, index)
        subArray = subArray.sort((a, b) => a.end > b.end ? 1 : -1)
        const lastService = subArray[subArray.length - 1]
        if (lastService && lastService.end && service.start[0]) {
            const end = dayjs(lastService.end, "HH:mm")
            const nextStart = dayjs(service.start[0], "HH:mm")
            var durationService = dayjs.duration(nextStart.diff(end));
            var hours = parseInt(durationService.asHours()) > 0 ? parseInt(durationService.asHours()) + " hour " : "";
            var minutes = Number(durationService.asMinutes()) % 60 > 0 ? Number(durationService.asMinutes()) % 60 + " minutes." : "";

            return hours + minutes
        }
    }



    const filteredStaffHour = getStaffHour()

    if (loading) {
        return <Loading />
    }


    return (
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', minHeight: '100vh', zIndex: 100, background: "#f1f4f9" }}>
            <div className="top-nav"  >
                <NavBar onBack={() => navigate(`/?date=${date}`)}>{isEdit ? "Edit Appointment" : "Add Appointment"}</NavBar>
            </div>
            <div style={{ padding: "20px 0" }}>
                {currentClient
                    ? <ClientCard isHideClientPhoneNumber={isHideClientPhoneNumber} currentClient={currentClient} setCurrentClient={setCurrentClient} isEdit={isEdit} />
                    : isEdit
                        ? null
                        : <ClientSearch isHideClientPhoneNumber={isHideClientPhoneNumber} setCurrentClient={setCurrentClient} />
                }
                <Form
                    form={form}
                    onFinish={onFinish}
                    style={{ textAlign: 'left' }}
                    initialValues={{
                        date: date ? new Date(dayjs(date)) : new Date(),
                        services: [
                            {
                                _id: [],
                                start: [start],
                                end: '',
                                duration: [],
                                preferred: true
                            }
                        ],
                        notes: ''
                    }}
                    footer={
                        <Button block type='submit' color='primary' size='large' shape='rounded'>
                            <SaveOutlined /> Save
                        </Button>
                    }
                    mode='card'
                    layout='vertical'
                >
                    <Form.Item
                        name='date'
                        label='Date'
                        trigger='onConfirm'
                        onClick={(e, datePickerRef) => {
                            datePickerRef.current?.open()
                        }}
                        rules={[{ required: true, message: 'Please select a date' }]}
                        disabled={isEdit}
                    >
                        <DatePicker
                            onConfirm={onDateChange}
                            min={new Date(dayjs())}
                            max={new Date(dayjs().add(1, 'month'))}
                        >
                            {value =>
                                value ? dayjs(value).format('YYYY-MM-DD') : <span style={{ color: "#cbcbcb" }}>Select date</span>
                            }
                        </DatePicker>
                    </Form.Item>

                    <Form.Array
                        name='services'
                        onAdd={addMoreService}
                        renderAdd={() => (
                            <span><AddCircleOutline /> Add Service</span>
                        )}
                        renderHeader={({ index }, { remove }) => (
                            <div>
                                {getWaitingTime(index) && (
                                    <div style={{ fontSize: "14px", color: "orange", fontWeight: "bold", marginBottom: 12 }}>
                                        <ClockCircleTwoTone twoToneColor="orange" /> Waiting {getWaitingTime(index)}
                                    </div>
                                )}
                                <span>Service {index + 1}</span>
                                {form.getFieldValue('services').length > 1 && (
                                    <Button
                                        color='danger'
                                        fill='none'
                                        onClick={() => removeService(index, remove)}
                                        style={{ float: 'right', padding: "0 0 0 20px", fontSize: 18, lineHeight: 1 }}
                                    >
                                        Remove <DeleteOutline />
                                    </Button>
                                )}
                            </div>
                        )}
                    >
                        {fields => fields.map(({ index }) => (
                            // ↓ shouldUpdate here re-renders the row when any form value changes
                            <Form.Item key={index} shouldUpdate noStyle>
                                {() => (
                                    <>
                                        <Form.Item
                                            name={[index, '_id']}
                                            label='Service'
                                            rules={[{ required: true, message: 'Please select service!' }]}
                                            trigger='onConfirm'
                                            onClick={(e, picker) => picker.current?.open()}
                                        >

                                            <CascadePicker
                                                ref={el => cascadeRefs.current[index] = el}  // ← per-row ref
                                                onConfirm={(value) => onServiceChange(value[1], index)}
                                                options={filteredMenu}
                                                confirmText={<Button shape='rounded' color='primary'>Confirm</Button>}
                                                onClose={() => filterServices('')}
                                                title={
                                                    <SearchBar
                                                        className='service-search-bar'
                                                        placeholder="Find service"
                                                        style={{
                                                            margin: "0 10px",
                                                            '--border-radius': '100px',
                                                            '--padding-left': '12px',
                                                            '--height': '40px',
                                                            '--background': '#f0f0f0'
                                                        }}
                                                        value={searchText}
                                                        onChange={filterServices}
                                                    />
                                                }
                                            >




                                                {() => {
                                                    const serviceId = form.getFieldValue('services')[index]?._id?.[1]
                                                    if (!serviceId) return <span style={{ color: "#cbcbcb" }}>Select Service</span>
                                                    const name = menu.find(s => s._id === serviceId)?.name ?? ''
                                                    return name || <span style={{ color: "#cbcbcb" }}>Select Service</span>
                                                }}
                                            </CascadePicker>
                                        </Form.Item>

                                        {/* ↓ now re-renders correctly because parent has shouldUpdate */}
                                        {form.getFieldValue('services')?.[index]?._id?.[1] && (
                                            <Form.Item
                                                name={[index, 'customName']}
                                                label='Custom Name'

                                            >
                                                <Input placeholder='Service name' type='text' clearable />
                                            </Form.Item>
                                        )}

                                        <Form.Item
                                            name={[index, 'price']}
                                            label='Price'
                                            rules={[{ required: true, message: 'Please input price!' }]}
                                        >
                                            <Input placeholder='Service price' type='number' min={0} />
                                        </Form.Item>

                                        <Form.Item
                                            name={[index, 'start']}
                                            label='Start Time'
                                            rules={[{ required: true, message: 'Please select start time!' }]}
                                            trigger='onConfirm'
                                            onClick={(e, picker) => picker.current?.open()}
                                        >
                                            <Picker
                                                onConfirm={(value) => onStarttimeChange(value[0], index)}
                                                columns={[getAvailableTime(filteredStaffHour, form.getFieldValue('services')[index])]}
                                            >
                                                {value => (value && value[0])
                                                    ? <div>
                                                        <div>{value[0]?.label}</div>
                                                        {form.getFieldValue('services')[index].end && (
                                                            <div style={{ fontSize: "14px", color: "gray" }}>
                                                                End at {dayjs(form.getFieldValue('services')[index].end, 'HH:mm').format('hh:mm a')}
                                                            </div>
                                                        )}
                                                    </div>
                                                    : <span style={{ color: "#cbcbcb" }}>select start time</span>
                                                }
                                            </Picker>
                                        </Form.Item>

                                        <Form.Item name={[index, 'end']} disabled style={{ display: "none" }}>
                                            <Input />
                                        </Form.Item>

                                        <Form.Item
                                            name={[index, 'duration']}
                                            label='Duration'
                                            rules={[{ required: true, message: 'Please select duration!' }]}
                                            trigger='onConfirm'
                                            onClick={(e, picker) => picker.current?.open()}
                                        >
                                            <Picker
                                                onConfirm={(value) => onDurationChange(value[0], index)}
                                                columns={[durationOptions]}
                                            >
                                                {value => (value && value[0])
                                                    ? value[0]?.label
                                                    : <span style={{ color: "#cbcbcb" }}>select duration</span>
                                                }
                                            </Picker>
                                        </Form.Item>

                                        <Form.Item
                                            name={[index, 'preferred']}
                                            label={
                                                <div>
                                                    Preferred
                                                    <Popover content='Client requested you as their preferred staff' trigger='click' mode='dark'>
                                                        <QuestionCircleFill style={{ fontSize: 16, color: "#cbcbcb", marginLeft: 5 }} />
                                                    </Popover>
                                                </div>
                                            }
                                            valuePropName='checked'
                                        >
                                            <Switch checkedText='Yes' uncheckedText='No' />
                                        </Form.Item>
                                    </>
                                )}
                            </Form.Item>
                        ))}
                    </Form.Array>

                    <Form.Item
                        name='notes'
                        label='Notes'
                    >
                        <TextArea
                            placeholder='Add an appointment note (visible to staff only)'
                            rows={3}
                        />
                    </Form.Item>
                </Form>
            </div>
        </div>
    )
}

export default CreateEditAppointment